import { useState } from 'react'
import TimesheetTable from './TimesheetTable'
import TimelogView from './TimelogView'
import styles from './TrackerSection.module.css'

export default function TrackerSection({ activeSubSection, onSubSectionChange, apiToken, user, availableProjects = [], availableTasks = [], onRefreshNeeded }) {
    const renderSubSectionContent = () => {
        switch (activeSubSection) {
            case 'timelog':
                return <TimelogView apiToken={apiToken} user={user} availableProjects={availableProjects} availableTasks={availableTasks} onRefreshNeeded={onRefreshNeeded} />
            case 'timesheet':
                return <TimesheetTable availableProjects={availableProjects} availableTasks={availableTasks} apiToken={apiToken} user={user} />
            default:
                return (
                    <div className={styles.subSectionContent}>
                        <h2>Time Tracking</h2>
                        <p>Track your time efficiently with our comprehensive tools.</p>
                        <div className={styles.cards}>
                            <div className={styles.card}>
                                <h3>Start Tracking</h3>
                                <p>Begin tracking your time with our intuitive timer</p>
                                <button className={styles.cardButton}>Get Started</button>
                            </div>
                        </div>
                    </div>
                )
        }
    }

    return (
        <div className={styles.trackerSection}>
            {/* Secondary Menu Bar */}
            <div className={styles.secondaryMenu}>
                <nav className={styles.subNav}>
                    <button
                        className={`${styles.subNavItem} ${activeSubSection === 'timelog' ? styles.active : ''}`}
                        onClick={() => onSubSectionChange('timelog')}
                    >
                        Timelog
                    </button>
                    <button
                        className={`${styles.subNavItem} ${activeSubSection === 'timesheet' ? styles.active : ''}`}
                        onClick={() => onSubSectionChange('timesheet')}
                    >
                        Timesheet
                    </button>
                </nav>
            </div>

            {/* Sub-section Content */}
            <div className={styles.contentArea}>
                {renderSubSectionContent()}
            </div>
        </div>
    )
}